export const PRODUCT_ONBOARDING_STEP_KEYS = {
  SALES_TAX_BUSINESS_DETAILS: "sales_tax_business_details",
  SALES_TAX_BUSINESS_OWNER_DETAILS: "sales_tax_business_owner_details",
  SALES_TAX_BUSINESS_ACTIVITY_DETAILS: "sales_tax_business_activity_details",
};
